import Vue from 'vue'
import { Message,MessageBox } from 'element-ui'

import './plugins/element.js'

import axiosApi from '@/api/axios.js'
import moment from 'moment'
// import Message from "element-ui/packages/message/src/main";
Vue.config.productionTip = false
    // 导入 NProgress 包对应的JS和CSS
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'



import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/index'
import App from './App.vue'
import router from './router'
import { menuPermission } from "./utils/menuPermission"; //菜单权限
import { buttonPermission } from "@/utils/buttonPermission"; //按钮权限
import VideoBlot from './utils/video.js';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

import echarts from 'echarts'
Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Quill.register(VideoBlot);


import tim from 'tim'
import TIM from 'tim-js-sdk'
import TWebLive from 'tweblive'
import Avatar from './components/avatar.vue'
// import './assets/icon/iconfont.css'
// import './assets/icon/tim.css'
// import trtcCalling from './trtc-calling'
import TRTCCalling from 'trtc-calling-js'
window.TIM = TIM
window.tim = tim
window.TRTCCalling = TRTCCalling
Vue.prototype.tim = tim
Vue.prototype.TWebLive = TWebLive
Vue.prototype.$store = store
Vue.prototype.TIM = TIM
Vue.prototype.TWebLive = TWebLive
// Vue.prototype.trtcCalling = trtcCalling
Vue.prototype.TRTCCalling = TRTCCalling
Vue.component('avatar', Avatar)

import preventClick from './utils/preventClick'  // 根据自己的路径
Vue.use(preventClick)

//视频
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

Vue.prototype.$message = Message;
Vue.prototype.$confirm=MessageBox.confirm;

Vue.prototype.$moment = moment;
//全局菜单权限变量
Vue.prototype.menuPerm = menuPermission;
Vue.prototype.btnPerm = buttonPermission;
Vue.use(ElementUI);
Vue.use(Antd);
Vue.use(axiosApi);
Vue.use(Viewer)
Vue.prototype.$echarts = echarts
Vue.prototype.$bus = new Vue()
//全局的常量
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')